import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "repexo-cookie-consent";

const CookieConsentContext = createContext(null);

export function CookieConsentProvider({ children }) {
  const [consent, setConsentState] = useState(null);
  const [showPreferences, setShowPreferences] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === "accepted" || stored === "rejected") {
        setConsentState(stored);
      }
    } catch (_) {
      // ignore
    }
  }, []);

  const setConsent = useCallback((value) => {
    setConsentState(value);
    setShowPreferences(false);
    try {
      if (value) {
        localStorage.setItem(STORAGE_KEY, value);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    } catch (_) {
      // ignore
    }
  }, []);

  const openCookiePreferences = useCallback(() => {
    setShowPreferences(true);
  }, []);

  const shouldShowBanner = consent === null || showPreferences;

  return (
    <CookieConsentContext.Provider
      value={{
        consent,
        setConsent,
        openCookiePreferences,
        shouldShowBanner,
      }}
    >
      {children}
    </CookieConsentContext.Provider>
  );
}

export function useCookieConsent() {
  const ctx = useContext(CookieConsentContext);
  return ctx;
}
